app.directive('confirmDialog', function($window, $document, throttle) {
    return {
        restrict: 'A',
        link: function($scope, $element, $attrs) {
            $element.on('click', function(event) {
                if (!window.confirm($attrs.confirmDialog)) {
                    event.preventDefault();
                }
            });
        }
    };
});
